import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/google.png'
import _imports_1 from '@/assets/images/who-we-1.jpg'
import _imports_2 from '@/assets/images/who-we-2.jpg'
import _imports_3 from '@/assets/images/border-3.png'
import _imports_4 from '@/assets/images/shape-10.png'


const _hoisted_1 = { class: "who-we-area pt-100 overflow-hidden bg-gondola2 position-relative z-1" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  class: "row",
  "data-cues": "zoomOut"
}
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "who-we-area-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createStaticVNode("<span class=\"top-title\">من نحن</span><h2 class=\"text-white\"> نفتخر بتقديم أفضل اشتراكات IPTV بجودة عالية </h2><p> تقدم Loay IPTV تجربة مشاهدة مستقرة وعالية الجودة، مع بث سريع وسلس بدون تقطيع أو تأخير. يمكنك التنقل بين القنوات بسهولة والاستمتاع بتجربة استخدام مريحة على مختلف الأجهزة. </p><div class=\"row align-items-center\"><div class=\"col-lg-9\"><ul class=\"ps-0 list-unstyled we-are-list\"><li><i class=\"ti ti-circle-check\"></i><span>تشغيل عدة أجهزة في الوقت نفسه</span></li><li><i class=\"ti ti-circle-check\"></i><span>بث سريع ومستقر بجودة عالية</span></li><li><i class=\"ti ti-circle-check\"></i><span>تجربة مشاهدة سلسة في كل مكان</span></li></ul></div><div class=\"col-lg-3\"><div class=\"google\"><img src=\"" + _imports_0 + "\" alt=\"google\"><p>التقييم <span>4.7</span></p></div></div></div>", 4)),
            _createVNode(_component_RouterLink, {
              to: "/contact-us",
              class: "btn"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"col-lg-6\"><div class=\"who-we-img-wrap\"><div class=\"row align-items-end\"><div class=\"col-lg-6 col-sm-6\"><div class=\"who-we-1 who-we-img\"><div class=\"row\"><div class=\"col-lg-6 col-sm-6\"><div class=\"review mb-minus-53\"><div class=\"review-in\"><span>تقييمات خمس نجوم</span><h1>500K</h1></div></div></div><div class=\"col-lg-6 col-sm-6\"><div class=\"review bg-golden\"><div class=\"review-in\"><span>اشتراك نشط</span><h1>5.3K</h1></div></div></div></div><img src=\"" + _imports_1 + "\" alt=\"who-we\"></div></div><div class=\"col-lg-6 col-sm-6\"><div class=\"who-we-2 who-we-img\"><img src=\"" + _imports_2 + "\" alt=\"who-we\"></div></div></div></div></div>", 1))
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_3,
      class: "border-3",
      alt: "border"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_4,
      class: "shape shape-10",
      alt: "shape"
    }, null, -1))
  ]))
}